// Compiler error remapper that restores imported-source file and line numbers.
// It rewrites merged-source `line N` diagnostics using import-resolution line maps.
import type { LuisSourceLineOrigin } from './imports/line-map-types'

const LINE_PATTERN = /\bline\s+(\d+)\b/i

// Rethrow one compile error after mapping merged lines back to source origins.
export function rethrowMappedCompileError(error: unknown, lineMap: LuisSourceLineOrigin[], rootSourceId: string): never {
  const resolved = error instanceof Error ? error : new Error(String(error))
  const match = resolved.message.match(LINE_PATTERN)
  // Keep the original error when no line information is available.
  if (!match) {
    throw resolved
  } else {
    // Continue source-line remap for errors with a line number.
  }

  const mergedLine = Number.parseInt(match[1], 10)
  const origin = lineMap[mergedLine - 1]
  // Keep the original error when merged line has no origin entry.
  if (!origin) {
    throw resolved
  } else {
    // Continue error-message rewrite with resolved origin info.
  }

  const nextMessage = rewriteErrorMessage(resolved.message, origin, rootSourceId)
  const remapped = new Error(nextMessage)
  remapped.name = resolved.name
  // Return the rewritten compile error.
  throw remapped
}

// Rewrite one error message to include the remapped source file and line.
function rewriteErrorMessage(message: string, origin: LuisSourceLineOrigin, rootSourceId: string): string {
  const lineRewritten = message.replace(LINE_PATTERN, `line ${origin.line}`)
  // Keep root-source errors unchanged apart from corrected line numbers.
  if (origin.sourceId === rootSourceId) {
    return lineRewritten
  } else {
    // Continue imported-source message enrichment.
  }

  if (lineRewritten.startsWith('Invalid .luis syntax')) {
    // Return enriched invalid-syntax message with imported source id.
    return lineRewritten.replace('Invalid .luis syntax', `Invalid .luis syntax in "${origin.sourceId}"`)
  } else {
    // Return a generic imported-source suffix for other error shapes.
    return `${lineRewritten} [source: ${origin.sourceId}]`
  }
}
